import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetApplicationList = {
  getApplicationList: { data: null, loading: false, error: null },
};

export const getApplicationList = createAsyncThunk('user/getApplicationList', async (data = {}, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/applications`, {
      params: data,
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetApplicationList = {
  [getApplicationList.pending]: (state) => {
    // state.getApplicationList.data = null;
    state.getApplicationList.loading = true;
    state.getApplicationList.error = null;
  },
  [getApplicationList.fulfilled]: (state, action) => {
    state.getApplicationList.loading = false;
    state.getApplicationList.data = action.payload;
    state.getApplicationList.error = null;
  },
  [getApplicationList.rejected]: (state, action) => {
    state.getApplicationList.loading = false;
    state.getApplicationList.error = action.payload;
  },
};
